export function IntegrationsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/integrations.svg'"></ng-include>`
    }
}